import * as React from 'react';

type Props = {
    Children: number;
    academicUser: boolean;
}

type State = {
    compare: number;
}

export default class RegistrationNavigation extends React.PureComponent<Props, State> {

    constructor(props:Props){
        super(props);

        this.state = {
            compare: 1,
        }
    }

    public render() {
        return <React.Fragment>
            <div className="col-md-2">
                <nav className="bs-docs-sidebar hidden-print hidden-sm hidden-xs affix">
                    <ul className="bs-docs-sidenav" style={{position:'fixed', listStyleType:'none' }}>
                        <li>
                            <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "child", this.props.Children - 1)} href="#">Child</a>
                            <ul style={{listStyleType:'none' }}>
                                <li>
                                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "information", this.props.Children - 1)} href="#">Information</a>
                                </li>
                                {!this.props.academicUser && <React.Fragment>
                                    <li>
                                        <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "infant", this.props.Children - 1)} href="#">Infant</a>
                                    </li>
                                </React.Fragment>}
                                <li>
                                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "emergency", this.props.Children - 1)} href="#">Emergency Contact</a>
                                </li>
                                {!this.props.academicUser && <React.Fragment>
                                    <li>
                                        <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "medical", this.props.Children - 1)} href="#">Medical</a>
                                    </li>
                                </React.Fragment>}
                                <li>
                                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "comments", this.props.Children - 1)} href="#">Comments</a>
                                </li>
                            </ul>
                        </li>
                        {this.props.Children && this.state.compare < this.props.Children && this.CreateNav()}
                        {!this.props.academicUser && <React.Fragment>
                            <li>
                                <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "guardian", 0)} href="#">Guardian</a>
                            </li>
                            <li>
                                <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "release", 0)} href="#">Release</a>
                            </li>
                        </React.Fragment>}
                        <li>
                            <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "terms", 0)} href="#">Agreements</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </React.Fragment>
    }

    CreateNav() {
        var num = this.props.Children - this.state.compare;
        var childNav = []
        for (var i = this.state.compare; i <= num; i++)  {childNav.push(<li>
            <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "child", this.props.Children - 1)} href="#">Child</a>
            <ul style={{listStyleType:'none' }}>
                <li>
                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "information", this.props.Children - 1)} href="#">Information</a>
                </li>
                <li>
                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "infant", this.props.Children - 1)} href="#">Infant</a>
                </li>
                <li>
                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "emergency", this.props.Children - 1)} href="#">Emergency Contact</a>
                </li>
                <li>
                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "medical", this.props.Children - 1)} href="#">Medical</a>
                </li>
                <li>
                    <a style={{textDecoration:'none'}} onClick={(e) => this.navChange(e, "comments", this.props.Children - 1)} href="#">Comments</a>
                </li>
            </ul>
        </li>)}
        return childNav;
    }

    private navChange(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, id:string, parse:number) {
        e.preventDefault()
        document.getElementsByClassName(id)[parse].scrollIntoView()
    }
}
